module.exports = __webpack_public_path__ + "static/media/34-10.fd0f8064.mp3";